import { render, staticRenderFns } from "./SubIframe.vue?vue&type=template&id=381915ee&"
import script from "./SubIframe.vue?vue&type=script&lang=js&"
export * from "./SubIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports